module.exports = __webpack_public_path__ + "ARIMO-ITALIC.0b7fbd35e3983840044e.ttf";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/PROD-mufit-web/src/assets/fonts/ARIMO-ITALIC.ttf
// module id = ../../../../../src/assets/fonts/ARIMO-ITALIC.ttf
// module chunks = styles